// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__27W5b"};